// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"884":"admin","933":"auth"}[chunkId] || chunkId) + "." + {"125":"94523a28","234":"725e062c","353":"acd116ab","884":"ae078a6a","933":"aea04258"}[chunkId] + ".js";
};